export const Text = () => {
  //
  return <>Component</>;
};
